import { AxiosError } from 'axios'
import React from 'react'

import HeadingWithReloadButton from '@/components/misc/ErrorMessage/components/HeadingWithReloadButton'
import RefreshPagePrompt from '@/components/misc/ErrorMessage/components/RefreshPagePrompt'
import { useCaptureErrorAfterTwoSeconds } from '@/components/misc/ErrorMessage/hooks/useCaptureErrorAfterTwoSeconds'
import { Button } from '@/components/ui/button'

interface Props {
  error: AxiosError
}

const RequestAbortedErrorMessage: React.FC<Props> = ({ error }) => {
  useCaptureErrorAfterTwoSeconds(error)

  return (
    <section className="relative">
      <HeadingWithReloadButton>Network issue detected</HeadingWithReloadButton>

      <p className="mb-2">
        Sorry, it looks like there might be an issue with your browser or
        network connection.
      </p>

      <RefreshPagePrompt />

      <Button onClick={() => window.location.reload()}>Refresh page</Button>
    </section>
  )
}

export default RequestAbortedErrorMessage
